<div class="login-container">
  <div
    class="flex flex-col md:flex-row w-full max-w-5xl h-full md:h-[600px] bg-white bg-opacity-90 backdrop-blur-lg rounded-2xl shadow-2xl overflow-hidden opacity-0 animate-fade-slide-up transition-all duration-1000">

    <!-- Left Side -->
    <div
      class="hidden md:flex flex-col justify-center items-center bg-gradient-to-br from-green-300 to-blue-400 w-full md:w-1/2 relative p-10">
      <!-- Decorative overlay -->
      <div class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-10 rounded-2xl z-0"></div>

      <!-- Text Section with Animation -->
      <div class="z-10 text-center opacity-0 animate-fade-slide-up transition-all duration-1000 ease-in-out">
        <h2 class="text-5xl font-bold text-white mb-6 leading-tight">Welcome Back!</h2>
        <p class="text-white text-lg font-light">
          Access your dashboard<br />
          Login to continue your journey!
        </p>
      </div>
    </div>

    <!-- Right Side Form -->
    <div class="form-wrapper md:w-1/2 w-full flex flex-col justify-center p-10">
      <div class="flex justify-center mb-8">
        <img class="w-[130px] h-[110px]" src="../../../../assets/images/nsc-logo.png" alt="Logo" />
      </div>
      <form class="max-w-md w-full mx-auto">
        <div class="mb-6">
          <app-generic-input-field id="UserName" label="Username" placeholder="Enter your Username"
            [control]="f['UserName']"></app-generic-input-field>
        </div>
        <div class="mb-4">
          <app-generic-input-field id="password" label="Password" type="password" placeholder="Enter your password"
            [control]="f['password']" [showPasswordEye]="true"></app-generic-input-field>
        </div>
        <div class="mt-1 mb-6 text-right text-red-400">
          <a [routerLink]="['/password-reset']" class="font-medium hover:underline">
            Forgot Password?
          </a>
        </div>
        <div class="flex items-center justify-center">
          <button class="signin-btn w-full" type="button" (click)="signIn()">
            Sign In
          </button>
        </div>
      </form>
    </div>

  </div>
</div>